import Vue from 'vue';
import Vuex from 'vuex';
import data from './modules/data.js';
import auth from './modules/auth.js';
import toast from './modules/toast.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // url: 'http://127.0.0.1:11223'
    // url: "http://carbis.keenetic.link:11031"
    // url: 'http://109.202.22.231:7110'
    url: 'https://reverse.carbis.ru'
  },
  mutations: {
  },
  actions: {
  },
  getters:{
    url(state){
      return state.url
    }
  },
  modules: {
    auth,
    toast,
    data,
  }
})
